export default __webpack_public_path__ + "img/Montserrat-Bold_5885feb.ttf";